import React, { useEffect, useState } from "react";
import { getData, putData } from "../../services/api.service";
import { useNavigate } from "react-router-dom";
import { swalAlertDanger, swalAlertSuccess } from "../../components/common/Alerts";
import Logo from "../../assets/img/Logo2.png";
import BackButton from "../../components/common/BackButton";
import ModalWindow from "../../components/ModalWindow";
import { FaPen } from "react-icons/fa";

const BranchSelection = () => {
  const navigate = useNavigate();
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingBranch, setEditingBranch] = useState(null);
  const [editForm, setEditForm] = useState({
    branch_name: "",
    address: "",
    phone: "",
    email: "",
    active: 1
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Obtener sucursales
        const res = await getData("/api/get_branches");
        if (res.status === 200) {
          setBranches(res.data.branches || res.data);
        } else {
          swalAlertDanger(
            "Error al obtener las sucursales",
            "",
            () => {}
          );
        }
      } catch (error) {
        swalAlertDanger("Error al obtener los datos", "", () => {});
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // useEffect para debuggear el estado del modal
  useEffect(() => {
    console.log("Estado del modal actualizado:", { showEditModal, editingBranch });
  }, [showEditModal, editingBranch]);

  const handleBranchSelection = (branchId) => {
    navigate(`/home/admin_panel/${branchId}`);
  };

  const handleEditBranch = (e, branch) => {
    console.log("handleEditBranch ejecutado con branch:", branch); // Debug
    e.stopPropagation(); // Evitar que se ejecute handleBranchSelection
    e.preventDefault();
    
    setEditingBranch(branch);
    setEditForm({
      branch_name: branch.branch_name || "",
      address: branch.address || "",
      phone: branch.phone || "",
      email: branch.email || "",
      active: branch.active !== undefined ? branch.active : 1
    });
    setShowEditModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSaveChanges = async () => {
    try {
      const dataToSend = {
        ...editForm,
        id: editingBranch.id
      };
      
      console.log("Datos a enviar:", dataToSend);
      console.log("ID de sucursal:", editingBranch.id);
      console.log("URL completa:", `/api/admin/update_branch/${editingBranch.id}`);
      
      const res = await putData(`/api/admin/update_branch/${editingBranch.id}`, dataToSend);
      console.log("Respuesta del servidor:", res);
      
      if (res.status === 200) {
        swalAlertSuccess("Éxito", "Sucursal actualizada correctamente", () => {});
        // Actualizar la lista de sucursales
        setBranches(prev => prev.map(branch => 
          branch.id === editingBranch.id 
            ? { ...branch, ...editForm }
            : branch
        ));
        setShowEditModal(false);
      } else {
        console.log("Error en la respuesta:", res.data);
        swalAlertDanger("Error al actualizar la sucursal", res.data?.message || "Error desconocido", () => {});
      }
    } catch (error) {
      console.log("Error capturado:", error);
      swalAlertDanger("Error al actualizar los datos", error.message || "Error de conexión", () => {});
    }
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
    setEditingBranch(null);
    setEditForm({
      branch_name: "",
      address: "",
      phone: "",
      email: "",
      active: 1
    });
  };

  return (
    <div className="container text-white mt-3">
      <div className="mb-5">
        <BackButton />
      </div>
      
      <div className="text-center mb-4">
        <h1>Panel de Administración</h1>
        <p className="lead">Selecciona la sucursal que deseas administrar</p>
      </div>

      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      ) : branches.length === 0 ? (
        <div className="alert alert-warning text-center my-5" role="alert">
          <h4>⚠️ Sin sucursales disponibles</h4>
          <p className="mb-0">
            No se encontraron sucursales disponibles para administrar.
          </p>
        </div>
      ) : (
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="d-grid gap-3">
              {branches.map((branch) => (
                <div
                  key={branch.id}
                  className="btn-outline-light btn-lg p-4 text-start bg-dark border-1 rounded position-relative"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleBranchSelection(branch.id)}
                >
                  {/* Botón de edición */}
                  <button
                    className="btn btn-sm btn-warning position-absolute"
                    style={{ 
                      top: "45px", 
                      right: "10px", 
                      padding: "8px 10px",
                      zIndex: 10,
                      border: "1px solid #ffc107"
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleEditBranch(e, branch);
                    }}
                    title="Editar sucursal"
                    type="button"
                  >
                    <FaPen size={12} color="#000" />
                  </button>
                  
                  <div className="d-flex align-items-center justify-content-between pe-5">
                    <div>
                      <h4 className="mb-1 text-white">{branch.branch_name}</h4>
                      <p className="mb-1 text-white">{branch.address}</p>
                      <small className="text-white">
                        {branch.phone && `📞 ${branch.phone}`}
                      </small>
                    </div>
                    <div className="text-end">
                      <div className="d-flex flex-column gap-1">
                        <span 
                          className={`badge ${branch.closed === 0 ? 'bg-success' : 'bg-danger'} fs-6`}
                        >
                          {branch.closed === 0 ? '🟢 Abierta' : '🔴 Cerrada'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="text-center mt-5">
        <img src={Logo} alt="LogoBottom" className="w-25 opacity-50" />
      </div>

      {/* Modal para editar sucursal */}
      {showEditModal && editingBranch && (
        <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Editar Sucursal: {editingBranch.branch_name}</h5>
                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="branch_name" className="form-label fw-bold">
                      Nombre de la Sucursal *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="branch_name"
                      name="branch_name"
                      value={editForm.branch_name}
                      onChange={handleInputChange}
                      placeholder="Ej: Billy Browns Centro"
                      required
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="address" className="form-label fw-bold">
                      Dirección *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="address"
                      name="address"
                      value={editForm.address}
                      onChange={handleInputChange}
                      placeholder="Ej: Av. Principal 123, Centro"
                      required
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label fw-bold">
                      Teléfono
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="phone"
                      name="phone"
                      value={editForm.phone}
                      onChange={handleInputChange}
                      placeholder="Ej: +54 11 1234-5678"
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label fw-bold">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={editForm.email}
                      onChange={handleInputChange}
                      placeholder="Ej: sucursal@billybrowns.com"
                    />
                  </div>
                  
                  {/* <div className="mb-3">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="active"
                        name="active"
                        checked={editForm.active === 1}
                        onChange={(e) => setEditForm(prev => ({
                          ...prev,
                          active: e.target.checked ? 1 : 0
                        }))}
                      />
                      <label className="form-check-label fw-bold" htmlFor="active">
                        Sucursal Activa
                      </label>
                      <small className="d-block text-muted">
                        {editForm.active === 1 ? 'La sucursal está activa' : 'La sucursal está inactiva'}
                      </small>
                    </div>
                  </div> */}
                </form>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Cancelar
                </button>
                <button 
                  type="button" 
                  className="btn btn-success"
                  onClick={handleSaveChanges}
                  disabled={!editForm.branch_name.trim() || !editForm.address.trim()}
                >
                  Guardar Cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BranchSelection;
